import axios from "axios";
import { ACCESS_TOKEN } from "./common";
import { ErrorAlert } from "../components/Alerts/SuccessAlert";

let isSessionExpired = false;

let activeRequests = 0;

const showLoader = () => {
  document.body.classList.add("loading-indicator");
};

const hideLoader = () => {
  document.body.classList.remove("loading-indicator");
};

function handleSessionTimeout() {
  if (isSessionExpired) return;
  isSessionExpired = true;

  const role = localStorage.getItem("role");
  localStorage.clear();

  ErrorAlert("Session expired. Please login again.");

  setTimeout(() => {
    switch (role) {
      case "super_admin":
        window.location.replace("/");
        break;
      case "school_admin":
        window.location.replace("/school-admin/login");
        break;
      case "teacher":
        window.location.replace("/teacher/login");
        break;
      default:
        window.location.replace("/");
    }
  }, 500);
}

const checkAuth = axios.create({
  // baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add tokens to headers
checkAuth.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem(ACCESS_TOKEN);
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    activeRequests++;
    showLoader();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Axios interceptors

checkAuth.interceptors.response.use(
  (response) => {
    activeRequests--;
    if (activeRequests === 0) hideLoader();
    return response;
  },

  (error) => {
    activeRequests--;
    if (activeRequests === 0) hideLoader();

    const status = error?.response?.status;
    const message =
      error?.response?.data?.detail || error?.response?.data?.message || "";

    // Token expired / invalid / logged out
    if (
      status === 401 ||
      (status === 403 && message.toLowerCase().includes("token"))
    ) {
      handleSessionTimeout();
    }

    return Promise.reject(error);
  },
);

export default checkAuth;
